<template>
  <div class="menu-content">
    <div>
      <i :class="getMenuIcon(menuType)"></i>
      <h2>{{ menuTitle }}内容区域</h2>
      <p>这里将显示{{ menuTitle }}的相关信息</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuType: {
      type: String,
      required: true,
      default: 'item'
    },
    menuTitle: {
      type: String,
      required: true,
      default: '物品查询'
    }
  },
  methods: {
    getMenuIcon(menu) {
      const icons = {
        'item': 'fas fa-cube',
        'monster': 'fas fa-dragon',
        'map': 'fas fa-map-marked-alt',
        'npc': 'fas fa-user-friends',
        'strategy': 'fas fa-book',
        'repair': 'fas fa-tools'
      };
      return icons[menu] || 'fas fa-question';
    }
  }
};
</script>

<style scoped>
.menu-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #666;
  text-align: center;
}

.menu-content i {
  font-size: 48px;
  margin-bottom: 20px;
  color: #ccc;
}

.menu-content div {
  max-width: 500px;
}

.menu-content h2 {
  margin-bottom: 10px;
  font-size: 28px;
}

.menu-content p {
  font-size: 18px;
  color: #999;
}

@media (max-width: 576px) {
  .menu-content {
    padding: 15px;
    font-size: 18px;
  }

  .menu-content h2 {
    font-size: 22px;
  }

  .menu-content p {
    font-size: 16px;
  }
}
</style>
